import { getShortenValue } from '../../../helpers/agentHelper';
import { useTranslation } from '../../../hooks/useTranslation';
import { AgentMetricsUnit } from '../../../interfaces/Agent';
import StyledAgentMetric from './StyledAgentMetric';

type AgentMetricProps = {
  alignItems?: 'flex-start' | 'center' | 'flex-end';
  flexDirection?: 'column' | 'column-reverse';
  fontSize?: '1.5rem' | '2.5rem';
  isRefreshing?: boolean;
  label?: string;
  unit?: AgentMetricsUnit;
  value?: number;
};

const renderValue = (
  unit: AgentMetricsUnit,
  value: number,
  minLabel: string
) => {
  switch (unit) {
    case AgentMetricsUnit.CURRENCY:
      return <h3>{getShortenValue(Number(value.toFixed(2)))} &euro;</h3>;
    case AgentMetricsUnit.MINUTE:
      return (
        <h3>{`${getShortenValue(Number(value.toFixed(0)))} ${minLabel}`}</h3>
      );
    case AgentMetricsUnit.PERCENT:
      return <h3>{`${value.toFixed(1)}%`}</h3>;
    default:
      return <h3>{getShortenValue(value)}</h3>;
  }
};

const AgentMetric: React.FC<AgentMetricProps> = ({
  alignItems = 'flex-start',
  flexDirection = 'column',
  fontSize = '1.5rem',
  isRefreshing = false,
  label,
  unit = AgentMetricsUnit.DEFAULT,
  value = 0,
}) => {
  const { t } = useTranslation();

  return (
    <StyledAgentMetric
      flexDirection={flexDirection}
      fontSize={fontSize}
      alignItems={alignItems}
      isRefreshing={isRefreshing}
    >
      {renderValue(unit, value, t('min'))}
      <p>{label}</p>
    </StyledAgentMetric>
  );
};

export default AgentMetric;
